var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"w-100"},[(_vm.block.platform == 1)?_c('BannersDesktop',{attrs:{"block":_vm.block}}):_vm._e(),(_vm.block.platform != 1)?_c('BannersMobile',{attrs:{"block":_vm.block}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }